import { VisitMedicalEventStatus } from '@dreryk/egabinet-visit-frontend-api';

import { createInterpolatedTranslationKey } from '@dreryk/react-common';
import { StatusIcon, StatusIconTooltip, TestId, TooltipPlacement } from '@dreryk/react-components';

import { useMedicalEventOptions } from './MedicalEventStatusIcon.hooks';

type MedicalEventStatusIconProps = {
   readonly visitMedicalEventStatus: VisitMedicalEventStatus;
   readonly testId: TestId;
};

const MedicalEventStatusIcon = (props: MedicalEventStatusIconProps): JSX.Element => {
   const { status, errorMessage } = props.visitMedicalEventStatus;
   const options = useMedicalEventOptions();

   return (
      <StatusIconTooltip
         tooltipText={createInterpolatedTranslationKey(`visit:medicalEvents.status:${status}`, {
            errorMessage: errorMessage,
         })}
         tooltipPlacement={TooltipPlacement.TOP}
         testId={'tooltip'}
      >
         <StatusIcon type={status} options={options} testId={props.testId} />
      </StatusIconTooltip>
   );
};

export { MedicalEventStatusIcon };
